import { jsx } from '@emotion/core';
var wrapperStyles = {
  position: 'relative',
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between'
};
export var Wrapper = function Wrapper(_a) {
  var className = _a.className,
      children = _a.children;
  return jsx("div", {
    css: wrapperStyles,
    className: className
  }, children);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Input/wrapper.js
// module id = 203
// module chunks = 0